<template>
    <TheOrganizationAddSpace :newSpaceType="spaceTypes.RESEARCH_SPACE" spaceTypeIcon="mdi-beaker"></TheOrganizationAddSpace>
</template>

<script>
import { enumsData } from '@/mixins/enums'
const TheOrganizationAddSpace = () => import('../components/TheHomeAddSpace')

export default {
    mixins: [enumsData],
    components: {
        TheOrganizationAddSpace
    }
}
</script>
